export default __webpack_public_path__ + "static/media/overlaybg.165362ee.png";